"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ScreenSize_1 = __importDefault(require("@web/common/ScreenSize"));
class ScrollWithMouseDrag {
    constructor(targetElement) {
        this.isDrawing = false;
        this.startX = 0;
        this.scrollLeft = 0;
        this.targetElement = targetElement;
        this.bindMousedownHandler = this.mousedownHandler.bind(this);
        this.bindMousemoveHandler = this.mousemoveHandler.bind(this);
        this.bindResetMouseHandler = this.resetMouseHandler.bind(this);
    }
    init() {
        const self = this;
        if (ScreenSize_1.default.isSmallScreen()) {
            this.destroy();
        }
        else {
            this.create();
        }
        window.addEventListener('resize', () => {
            if (ScreenSize_1.default.isSmallScreen()) {
                self.destroy();
            }
            else {
                self.create();
            }
        });
    }
    create() {
        this.targetElement.classList.add('mouse-drag');
        this.targetElement.addEventListener('mousedown', this.bindMousedownHandler);
        this.targetElement.addEventListener('mousemove', this.bindMousemoveHandler);
        this.targetElement.addEventListener('mouseleave', this.bindResetMouseHandler);
        this.targetElement.addEventListener('mouseup', this.bindResetMouseHandler);
    }
    destroy() {
        this.targetElement.classList.remove('mouse-drag');
        this.targetElement.removeEventListener('mousedown', this.bindMousedownHandler);
        this.targetElement.removeEventListener('mousemove', this.bindMousemoveHandler);
        this.targetElement.removeEventListener('mouseleave', this.bindResetMouseHandler);
        this.targetElement.removeEventListener('mouseup', this.bindResetMouseHandler);
    }
    mousedownHandler(event) {
        event.preventDefault();
        this.isDrawing = true;
        this.targetElement.classList.add('active');
        this.startX = event.pageX - this.targetElement.offsetLeft;
        this.scrollLeft = this.targetElement.scrollLeft;
    }
    mousemoveHandler(event) {
        event.preventDefault();
        if (this.isDrawing) {
            const x = event.pageX - this.targetElement.offsetLeft;
            const offsetX = (x - this.startX);
            this.targetElement.scrollLeft = this.scrollLeft - offsetX;
        }
    }
    resetMouseHandler() {
        this.isDrawing = false;
        this.targetElement.classList.remove('active');
    }
}
exports.default = ScrollWithMouseDrag;
